
let isClicked= false

function hoverImg(element) {
  // element.setAttribute('src', './images/copyed_icon.png');
  element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copyed_icon.png');
}

function removehoverImg(element) {
  // !isClicked &&	element.setAttribute('src', './images/copy_icon.png');
  !isClicked &&	element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_icon.png');
}

function doneCopy(element) {

  let mailBtn = document.querySelector('#mail_btn')
  // let careerMailData = document.getElementById('career_mail').innerHTML = 'careers@quokkalabs.com'
  let careerMailData = document.getElementById('career_mail').innerText
  // console.log(careerMailData);
  mailBtn.addEventListener('click',()=>{
    navigator.clipboard.writeText(careerMailData)
    .then(() => {
      console.log('Text copied to clipboard');
    })
    .catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  })










  // element.setAttribute('src', './images/copy_done.png');
  element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_done.png');
  isClicked = true
  setTimeout(()=>{
    isClicked = false
    // element.setAttribute('src', './images/copy_icon.png')
    element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_icon.png')
  },2000)
  return isClicked;
}



window.hoverImg = hoverImg;
window.removehoverImg = removehoverImg;
window.doneCopy = doneCopy;